
import { supabase } from './supabaseClient';
import { Pedido, ItemPedido, OrderStatus } from '../types';

export const pedidosService = {
  async getPedidos(empresaId: string): Promise<Pedido[]> {
    const { data } = await supabase
      .from('pedidos')
      .select('*')
      .eq('empresa_id', empresaId)
      .order('created_at', { ascending: false });
    return data || [];
  },

  async getItensPedido(pedidoId: string): Promise<ItemPedido[]> {
    const { data } = await supabase.from('itens_pedido').select('*').eq('pedido_id', pedidoId);
    return data || [];
  },

  async atualizarStatusPedido(pedidoId: string, status: OrderStatus) {
    const { data, error } = await supabase
      .from('pedidos')
      .update({ status })
      .eq('id', pedidoId)
      .select();
    
    if (error) throw new Error(error.message);
    if (!data || data.length === 0) throw new Error("Nao foi possivel atualizar o status.");
  },

  async criarPedido(empresa_id: string, cliente: any, itens: any[]) {
    const { data, error } = await supabase.functions.invoke('process-order', {
      body: {
        empresa_id,
        cliente,
        itens
      }
    });

    if (error) throw error;
    return data;
  },

  subscribePedidos(empresaId: string, onUpdate: (payload: any) => void) {
    return supabase
      .channel(`db-changes-${empresaId}`)
      .on(
        'postgres_changes',
        {
          event: '*', 
          schema: 'public',
          table: 'pedidos',
          filter: `empresa_id=eq.${empresaId}`
        },
        onUpdate
      )
      .subscribe();
  }
};
